export default `p=cos(p);
    float s=2., e;
    for(int j=0;j++<7;)
      p=1.8-abs(p-1.2),
      p=p.x<p.y?p.zxy:p.zyx,
      s*=e=4.5/min(dot(p,p),1.5),
      p=p*e-vec3(.2,3.0,4.0);
    return length(p.xz)/s;
  }`